import { useLimitTransaction } from "@/hooks/credit/use-limit-transaction";
import LimitExpiredCreditModal, {
  LimitExpiredCreditModalProps,
} from "@/components/modal/license-limited-modals/credit/base/limit-expired-credit-modal";
import { $creditPriceList } from "@/data/credit-transaction.constants";

const CustomVoiceLimitExpiredModal = ({
  handleUseCreditsClick,
}: LimitExpiredCreditModalProps) => {
  const { buyCustomVoiceLimit } = useLimitTransaction();

  return (
    <LimitExpiredCreditModal
      action={"custom voice"}
      priceInCredits={$creditPriceList.customVoiceLimitPrice}
      onUseCreditsClick={() =>
        handleUseCreditsClick(
          buyCustomVoiceLimit,
          $creditPriceList.customVoiceLimitPrice,
        )
      }
    />
  );
};

export default CustomVoiceLimitExpiredModal;
